import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/videoData';
import ArticleCard from '@/components/feature/ArticleCard';

export default function LatestArticles() {
  const { t } = useTranslation();
  const latest = articles.slice(0, 4);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            {t('latest_articles')}
          </h2>
          <Link to="/category/keji" className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap">
            {t('view_all')} <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="flex flex-col gap-4">
          {latest.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>
      </div>
    </section>
  );
}